import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'superflex-limpiar-btn',
    template: `
        <p-button
            label="{{'BOTONES.btnLimpiar' | translate}}"
            [icon]="icon"
            [styleClass]="styleClass"
            [class]="class"
            (onClick)="onClick.emit()"
            [disabled]="isDisabled">
        </p-button>`,
})
export class LimpiarBtnComponent {

    @Input() isDisabled: boolean;
    @Output() onClick = new EventEmitter<any>();
    @Input() icon = '';
    @Input() styleClass = 'p-button-outlined p-mr-2';
    @Input() class = '';

    constructor() {/***/}
}
